import { Box, Button, Menu, MenuItem } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { ArrowDropDown as ArrowDownIcon, ArrowDropUp as ArrowDropUpIcon } from '@mui/icons-material/';
import classes from './TipsterDropdown.module.scss';
import { Tipster } from "../../enums/Tipster";

const TipsterPreferencesDropdown = ({setHasTips, hasTips}: {setHasTips: (hasTips: boolean | null) => void, hasTips: boolean | null}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [selectedOption, setSelectedOption] = useState<Tipster | null>(null);
  const isOpen = useMemo(() => Boolean(anchorEl), [anchorEl]);

  const onTipsterButtonClickHandler = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (null === hasTips) {
      setSelectedOption(null);
    } else {
      setSelectedOption(hasTips ? Tipster.WITH_TIPS : Tipster.WITHOUT_TIPS);
    }
  }, [hasTips])

  const menuItemClickHandler = useCallback((option: Tipster) => {
    setAnchorEl(null);

    if (selectedOption === option) {
      setSelectedOption(null);
      setHasTips(null);
    } else {
      setSelectedOption(option);
      setHasTips(option === Tipster.WITH_TIPS);
    }
  }, [selectedOption, setHasTips]);

  return <>
    <Box>
      <Button
        onClick={onTipsterButtonClickHandler}
        className={`button-text filter-button ${isOpen ? classes['selected-filter-button'] : classes['filter-button']}`}
        endIcon={isOpen ? <ArrowDropUpIcon /> : <ArrowDownIcon />}
      >
        {selectedOption ?? 'Tips Content'}
      </Button>
    </Box>
    <Menu
      className='mt-2'
      classes={{ list: classes['options-box'], paper: classes['menu-paper'] }}
      anchorEl={anchorEl}
      open={isOpen}
      onClose={() => setAnchorEl(null)}
    >
      <MenuItem
        selected={selectedOption === Tipster.WITH_TIPS}
        onClick={() => menuItemClickHandler(Tipster.WITH_TIPS)}
      >
        With Tips
      </MenuItem>
      <MenuItem
        selected={selectedOption === Tipster.WITHOUT_TIPS}
        onClick={() => menuItemClickHandler(Tipster.WITHOUT_TIPS)}
      >
        Without Tips
      </MenuItem>
    </Menu>
  </>
}

export default TipsterPreferencesDropdown;
